(() => {
  const button = document.querySelector('[data-tc-butterfly-toggle]');
  if (!button || button.dataset.ready) return;
  button.dataset.ready = 'true';
  const root = document.documentElement;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false;
  try { paused = sessionStorage.getItem('tc-butterflies-paused') === 'true'; } catch {}
  const update = () => {
    root.toggleAttribute('data-tc-butterflies-paused', paused || preference.matches);
    button.hidden = preference.matches;
    button.setAttribute('aria-pressed', String(paused));
    button.textContent = paused ? 'Resume butterfly motion' : 'Pause butterfly motion';
  };
  button.addEventListener('click', () => {
    paused = !paused;
    try { sessionStorage.setItem('tc-butterflies-paused', String(paused)); } catch {}
    update();
  });
  preference.addEventListener('change', update);
  update();
})();
